import LocationCitySearchResourceModel from '../../generated/types/model/resource/LocationCitySearchResourceModel';

export default class LocationCitySearchResourceViewModel extends LocationCitySearchResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
